import { useState } from 'react'
import Select from 'react-select'
import Button from '../../general/Button'
import Translation from '../../Translation/cont/Translation'

const MoviesListDropAllItemsSelect = ({
    labelTransId,
    options, 
    stateKey, 
    filterKey = false, 
    labelKey, 
    valueKey, 
    setValue
}) => (
    <div>
        <div className="selection-label text-xsmall-light"><Translation id={labelTransId}/></div>

        <Select
            className="select-container"
            classNamePrefix="select"
            getOptionLabel={option => option[labelKey]}
            getOptionValue={option => option[valueKey]}
            isClearable={false}
            options={options}
            defaultValue={options[0]}
            onChange={value => {
                if(filterKey) {
                    setValue(prevState => ({
                        ... prevState,
                        [stateKey]: {
                            ... prevState[stateKey],
                            [filterKey]: value
                        }
                    }))
                } else {
                    setValue(prevState => ({
                        ... prevState,
                        [stateKey]: value
                    }))
                }
            }}
        />
    </div>
)

const MoviesFilterActions = ({
    filterConfig,
    filterOptions,
    targetOptions,
    actionOptions,
    onAction
}) => {
    const filterDefault = {}

    filterConfig.map(({id}) => filterDefault[id] = filterOptions[id][0])

    const [values, setValue] = useState({
        filter: filterDefault,
        ...(targetOptions && {target: targetOptions[0]}),
        action: actionOptions[0]
    })

    return (
        <div className="program-list-filter gap-30">
            <div className="filter-grid">
                {filterConfig.map(({id, transId}) => <MoviesListDropAllItemsSelect
                    key={id}
                    labelTransId={transId}
                    options={filterOptions[id]}
                    stateKey='filter'
                    filterKey={id}
                    labelKey='name'
                    valueKey='name'
                    setValue={setValue}
                />)}

                {targetOptions && 1 < targetOptions.length && <MoviesListDropAllItemsSelect
                    labelTransId="list_filter_target"
                    options={targetOptions}
                    stateKey='target'
                    labelKey='headlineClient'
                    valueKey='pk'
                    setValue={setValue}
                />}

                <MoviesListDropAllItemsSelect
                    labelTransId="list_filter_action"
                    options={actionOptions}
                    stateKey='action'
                    labelKey='name'
                    valueKey='id'
                    setValue={setValue}
                />
            </div>

            <Button
                className="button button-selection"
                transId="program_list_button_selection"
                hideText={false}
                onClick={() => onAction(values)}
            />
        </div>
    )
}

export default MoviesFilterActions